/* eslint-disable no-restricted-imports -- @lingui/core imports are allowed in libs/i18n */
import {i18n} from "@lingui/core";
import {LinguiContext} from "@lingui/react";

// Define a static context object that we pass in to LinguiContext.Provider
// More info: https://github.com/lingui/js-lingui/blob/main/packages/react/src/I18nProvider.tsx
const linguiContext = {
    i18n,
    _: i18n._.bind(i18n),
};

/**
 * Context provider for Lingui.
 *
 * We use our own provider instead of using I18nProvider because we never
 * want to re-render the app with a different locale, nor re-render if the
 * translated strings change.
 */
export const LinguiI18nProvider = ({children}: {children: React.ReactNode}) => (
    <LinguiContext.Provider value={linguiContext}>
        {children}
    </LinguiContext.Provider>
);
